import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SnackBarUI from '../../comman/SnackBarUI'
import { getAllPartnerAction } from '../../redux/toolkit/partner/allPartner';


import { isActivePartnerAction } from '../../redux/toolkit/partner/livePartner'

const LivePartner = ({is_active,state,setState,id}) => {
   const dispatch = useDispatch()
      const partnerRes = useSelector(state => state.partnerActive)
      const { status, message } = partnerRes
  
      const [snack, setSnack] = useState(false)
  
      // fn
      const handleClose = () => {
        setState(false)
      }
  
      const delCatHandle = async () => {
          const partnerLive = await dispatch(isActivePartnerAction({is_active:is_active,id:id}))


           dispatch(getAllPartnerAction({ page: 0, pageSize: 25 }))

         
          setSnack(true)
          setState(false)
      }
  
      return (
          <>
              <Dialog open={state} onClose={handleClose}>
                  <DialogTitle>{`Make  ${is_active ? "Active":"InActive" } Partner`}</DialogTitle>
                  <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                          Are you sure you want to `{is_active ? "Active":"InActive"}`This Partner
                      </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                      <Button onClick={delCatHandle} autoFocus>Submit</Button>
                      <Button onClick={handleClose}>Cancel</Button>
                  </DialogActions>
              </Dialog>
  
  
              <SnackBarUI state={snack} setState={setSnack} status={state} message={message} />
          </>
  
      )
}

export default LivePartner
